import { ILineCardPricingLineAssuranceProps } from '../LineCard.types';
import { useCalcAssurance } from 'pages/Phone/hooks/useCalcAssurance';
import PriceLine from '../PriceLine/PriceLine';

const LineCardPricingLineAssurance = (props: ILineCardPricingLineAssuranceProps) => {
    const { retailPrice } = props;

    const { sku: assuranceSku } = useCalcAssurance(retailPrice);

    return <PriceLine title={'Assurance Protection Plan'} monthlyPrice={assuranceSku?.price} />;
};

export default LineCardPricingLineAssurance;
